import { Button, Tooltip } from "@/design-system/components/ui";

/**
 * J5 — a collapsed card's one header action: the SAME action as the body's
 * button for the card's state, under the same enabled/disabled rule. A disabled
 * action with a reason (an unsaved edit, the server's blocked reason) carries
 * that sentence as its tooltip; the wrapper is focusable because a disabled
 * button receives neither hover nor focus.
 */
export function HeaderAction({
  label,
  onClick,
  disabled = false,
  reason,
  testId,
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  /** Why it is disabled, shown on hover / focus. Ignored while enabled. */
  reason?: string | null;
  testId?: string;
}) {
  const button = (
    <Button size="sm" onClick={onClick} disabled={disabled} data-testid={testId}>
      {label}
    </Button>
  );
  if (!disabled || !reason) return button;
  return (
    <Tooltip label={reason}>
      <span tabIndex={0} aria-label={`${label}: ${reason}`} className="inline-flex" data-testid={testId ? `${testId}-reason` : undefined}>
        {button}
      </span>
    </Tooltip>
  );
}
